module.exports = __webpack_public_path__ + "img/chess_chinesechessblack4.cd6966d1.png";